var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimpieza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.173,
    height: 92,
    viewBox: "0 0 95.173 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_004---Cleaning-Products",
    "data-name": "004---Cleaning-Products",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M26,56.531a1.586,1.586,0,0,0,1.586,1.586h6.835a1.586,1.586,0,0,0,1.586-1.461l.634-7.968a1.586,1.586,0,1,0-3.163-.251l-.525,6.507H27.586A1.586,1.586,0,0,0,26,56.531Z",
    transform: "translate(15.242 27.538)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M.3,60.331A11.887,11.887,0,0,0,8.864,74.466l.317,4.072A6.365,6.365,0,0,0,15.5,84.379H51.128a6.365,6.365,0,0,0,6.324-5.839L61.747,24.1h1.7a3.172,3.172,0,0,0,3.172-3.172A7.923,7.923,0,0,0,58.69,13H7.931A7.941,7.941,0,0,0,0,20.931,3.172,3.172,0,0,0,3.173,24.1H4.884l.944,11.939Zm4.787,8.09a8.724,8.724,0,0,1-1.694-7.385L6.662,46.691C7.654,59.39,7.919,62.632,8,63.521a1.567,1.567,0,0,0,.038.344,3.783,3.783,0,0,0,.776,1.586,3.907,3.907,0,0,0,3.079,1.48h6.028a10.32,10.32,0,0,0,9.993-7.725l6.941-26.82a7.1,7.1,0,0,0,4,1.234c.211,0,.409-.044.615-.062L32.518,60.41A15.061,15.061,0,0,1,17.924,71.69H11.9a8.624,8.624,0,0,1-6.821-3.271ZM41.613,23.628l.022.019a3.966,3.966,0,1,1-5.539,0l.027-.022a3.939,3.939,0,0,1,5.49,0ZM54.29,78.29a3.172,3.172,0,0,1-3.161,2.917H15.5a3.172,3.172,0,0,1-3.161-2.915l-.27-3.429h5.853A18.232,18.232,0,0,0,35.576,61.208L43.112,32.18A6.97,6.97,0,0,0,45.567,24.1h13ZM7.931,16.172H58.69a4.749,4.749,0,0,1,4.759,4.759H43.3a6.979,6.979,0,0,0-8.862,0H3.173a4.759,4.759,0,0,1,4.759-4.759ZM32.162,24.1a6.854,6.854,0,0,0,.194,5.284L24.845,58.415a7.147,7.147,0,0,1-6.921,5.344H11.9a.768.768,0,0,1-.634-.317.655.655,0,0,1-.111-.2c-.135-1.428-1.586-20.018-2.143-27.224L8.066,24.1Z",
    transform: "translate(0 7.621)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M50.345,53.759H47.172V50.586a1.586,1.586,0,1,0-3.172,0v3.172a3.172,3.172,0,0,0,3.172,3.172h3.172a1.586,1.586,0,0,0,0-3.172Z",
    transform: "translate(25.794 28.724)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M65.966,0H51.69a6.324,6.324,0,0,0-5.463,3.172H43.759a4.759,4.759,0,1,0,0,9.517h2.468a6.367,6.367,0,0,0,2.29,2.29v8.156L45.81,25.844a1.586,1.586,0,1,0,2.243,2.243l2.708-2.708a3.15,3.15,0,0,0,.93-2.243V15.862h3.172V27.224a6.331,6.331,0,0,1-1.629,4.243l-10.2,11.338a9.5,9.5,0,0,0-2.444,6.367v33.31A9.527,9.527,0,0,0,50.1,92h12.69a9.527,9.527,0,0,0,9.517-9.517V6.345A6.345,6.345,0,0,0,65.966,0ZM43.759,9.517a1.586,1.586,0,0,1-1.586-1.586A1.545,1.545,0,0,1,42.658,6.8a1.518,1.518,0,0,1,1.1-.457h1.586V9.517Zm4.759,0V6.345A3.172,3.172,0,0,1,51.69,3.172H65.966a3.172,3.172,0,0,1,3.172,3.172V12.69H51.69A3.172,3.172,0,0,1,48.517,9.517Zm20.621,6.345v6.345h-11.1V15.862ZM45.388,44.928,55.59,33.59a9.492,9.492,0,0,0,2.444-6.365V25.379h11.1V50.759H43.759V49.172a6.345,6.345,0,0,1,1.629-4.245Zm23.75,26.452H43.759V53.931H69.138ZM62.793,88.828H50.1a6.345,6.345,0,0,1-6.345-6.345V74.552H69.138v7.931A6.345,6.345,0,0,1,62.793,88.828Z",
    transform: "translate(22.863)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimpieza);
export default __webpack_public_path__ + "static/media/limpieza.47be79e8259cf78fc3e66e6eec304e63.svg";
export { ForwardRef as ReactComponent };